import { IAppState } from '../common/state';
import { offerTypeFromJsonQuery, FOfferType } from '../utils/category';

export const getOfferType = ({ filters: { jsonQuery } }: IAppState): FOfferType => {
  return offerTypeFromJsonQuery(jsonQuery);
};
